const SFAPI_VERSION = "2025-04";
export {
  SFAPI_VERSION
};
//# sourceMappingURL=storefront-api-constants.mjs.map
